import RenderOnViewportEntry from '@creator/ui/components/RenderOnViewportEntry/RenderOnViewportEntry';
import { cn } from '@creator/ui/utils/ui';
import AdvertisingSlot from '@src/components/Ads/AdvertisingSlot';
import PostList from '@src/components/Post/PostList/PostList';
import { memo, useMemo, useRef } from 'react';
import type { FC } from 'react';

export interface TokenSidebarProps {
    tokenName: string;
    className?: string;
    postId?: string; // in case of post page
    showRecommendedPosts?: boolean;
}
const POST_CARD_COMPACT_HEIGHT = 112 + 16; // 112px for the post card height + 16px for the margin

const TokenSidebar: FC<TokenSidebarProps> = props => {
    const { className, postId, tokenName, showRecommendedPosts } = props;

    const ref = useRef<HTMLDivElement>(null);

    const calculatedFetchLimit = useMemo(() => {
        if (!ref.current) return 0;
        const totalHeight = ref.current.getBoundingClientRect().height;
        let totalChildrenHeight = 0;
        for (let i = 0; i < ref.current.children.length; i++) {
            const child = ref.current.children[i];
            if (!(child instanceof HTMLElement)) continue;
            totalChildrenHeight += child.getBoundingClientRect().height;
        }
        const freeSpace = totalHeight - totalChildrenHeight;
        const freeSpaceInPostCards = Math.floor(freeSpace / POST_CARD_COMPACT_HEIGHT);
        if (freeSpaceInPostCards < 0) return 0;
        return Math.min(10, freeSpaceInPostCards);
    }, [showRecommendedPosts, ref.current]);

    function renderAd() {
        return <AdvertisingSlot divIdSufix={postId} className="mx-auto" location="mid_right" playWireLocation="top_right" tokenName={tokenName} />;
    }

    function renderRecommendedPosts() {
        if (!showRecommendedPosts) return null;
        return <PostList type="recommended" tokenName={tokenName} className="" fetchLimit={calculatedFetchLimit} />;
    }

    return (
        <div ref={ref} className={cn('space-y-4 p-4 border-l border-gray-200 dark:border-gray-600 ', className)}>
            <RenderOnViewportEntry className="space-y-4">
                {renderAd()}
                {renderRecommendedPosts()}
            </RenderOnViewportEntry>
        </div>
    );
};

export default memo(TokenSidebar);
